import { gql } from 'graphql-request';
import {
  ProductID,
  ProductUUID,
  ProductImageID,
  ProductImageName,
  ProductImageFile,
  ProductImageSize,
  ProductImageUUID,
  ProductNanoID
} from '../productsTypes';

export interface CacheFetchShowProductImageQueryResponseImage {
  id: ProductImageID;
  uuid: ProductImageUUID;
  file: ProductImageFile;
  size: ProductImageSize;
  name: ProductImageName;
}

export interface CacheFetchShowProductImageQueryResponse {
  id: ProductID;
  nanoId: ProductNanoID;
  uuid: ProductUUID;
  image: CacheFetchShowProductImageQueryResponseImage;
}

export const CACHE_FETCH_SHOW_PRODUCT_IMAGE_QUERY = gql`
  query CacheShowProductImage($uuid: ID!, $source: String) {
    product(uuid: $uuid, source: $source) {
      id
      nanoId
      uuid
      image {
        id
        uuid
        size
        name
        file
      }
    }
  }
`;
